var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentalHealthIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mental_Health-Icons",
    clipPath: "url(#clip0_11272_2766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.713 18.1476C18.713 18.1476 22.5044 16.7696 22.5044 14.0137C22.5044 12.8717 21.5756 11.9429 20.4336 11.9429C19.7408 11.9429 19.0937 12.2931 18.713 12.8717C18.0811 11.92 16.7945 11.6612 15.8429 12.2931C15.2643 12.6737 14.9217 13.3209 14.9141 14.0137C14.9141 16.7696 18.7054 18.1476 18.7054 18.1476H18.713Z",
    stroke: "#148D9B",
    strokeWidth: 1.28345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.8488 36.7388V27.6182C27.8488 26.3773 28.2523 25.1439 29.0669 24.2075C33.8708 18.6803 33.6196 10.1231 27.9554 4.90812C24.0955 1.35277 18.4237 0.271701 13.5513 2.22067C8.0774 4.41326 4.75045 9.59022 4.75806 15.1326V16.0005C4.75806 16.1908 4.70477 16.3812 4.61341 16.541L1.69757 21.619C1.38543 22.1672 1.5986 22.8752 2.1772 23.1417L4.14139 24.0781C4.52205 24.2608 4.76567 24.6415 4.76567 25.0602V28.9886C4.76567 30.8995 6.31876 32.4526 8.22967 32.4526H11.2673C12.3332 32.4526 13.1935 33.3129 13.1935 34.3787V36.7312H27.864L27.8488 36.7388Z",
    stroke: "#148D9B",
    strokeWidth: 1.28345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.713 22.3425C22.9177 22.3425 26.3262 18.934 26.3262 14.7294C26.3262 10.5247 22.9177 7.11621 18.713 7.11621C14.5084 7.11621 11.0999 10.5247 11.0999 14.7294C11.0999 18.934 14.5084 22.3425 18.713 22.3425Z",
    stroke: "#148D9B",
    strokeWidth: 1.28345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11272_2766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4321,
    height: 37,
    fill: "white",
    transform: "translate(0.783936 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthIcons);
export default __webpack_public_path__ + "static/media/Mental_Health-Icons.1923a7822c9fee73159d5c2e93184636.svg";
export { ForwardRef as ReactComponent };